import script from "./payanother.vue?vue&type=script&setup=true&lang=js"
export * from "./payanother.vue?vue&type=script&setup=true&lang=js"

import "./payanother.vue?vue&type=style&index=0&id=7b567c6a&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b567c6a"]])

export default __exports__